function meetingroomSearchRules(app) {
  return {
    // オーナーEXID チェック  ・桁数チェック  ・型チェック
    ownerExId: [
      {
        max: 20,
        trigger: 'blur',
        message: app.$t('message.common.validation.maxNumber', {
          field: app.$t('label.system.meetingRoom.search.query.ownerExId'),
          length: 20
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.meetingRoom.search.query.ownerExId'),
          type: '半角英数字'
        })
      }
    ],
    // オーナー名 チェック  ・桁数チェック  ・型チェック
    ownerName: [
      {
        max: 50,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.meetingRoom.search.query.ownerName'),
          length: 50
        })
      }
    ],
    // ビルID チェック  ・桁数チェック  ・型チェック
    buildingExId: [
      {
        max: 20,
        trigger: 'blur',
        message: app.$t('message.common.validation.maxNumber', {
          field: app.$t('label.system.meetingRoom.search.query.buildingExId'),
          length: 20
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.meetingRoom.search.query.buildingExId'),
          type: '半角英数字'
        })
      }
    ],
    // ビル名 チェック  ・桁数チェック  ・型チェック
    buildingName: [
      {
        max: 50,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.meetingRoom.search.query.buildingName'),
          length: 50
        })
      }
    ],
    // フロア チェック  ・桁数チェック  ・型チェック
    floorName: [
      {
        max: 50,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.meetingRoom.search.query.floorSelect'),
          length: 50
        })
      }
    ],
    // エリア名 チェック  ・桁数チェック  ・型チェック
    areaName: [
      {
        max: 50,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.meetingRoom.search.query.areaName'),
          length: 50
        })
      }
    ],
    // 会議室名 チェック  ・桁数チェック  ・型チェック
    meetingRoomName: [
      {
        max: 50,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.meetingRoom.search.query.fixDeskName'),
          length: 50
        })
      }
    ]
  }
}

export default {
  meetingroomSearchRules: meetingroomSearchRules
}
